interface CanonicalTripInput {
    tripId: string;
    carrierCode: string;
    mode: string;
    departCityCode?: string;
    arriveCityCode?: string;
    departWid: string;
    arriveWid: string;
    isRouted: boolean;
    transferCount: number;
    ticketPriceUsd: number;
}

interface CanonicalTrip {
    trip_id: string;
    carrier_code: string;
    mode: string;
    depart_city_code?: string;
    arrive_city_code?: string;
    depart_wid: string;
    arrive_wid: string;
    is_routed: boolean;
    transfer_count: number;
    ticket_price_usd: number;
}

interface CanonicalPricingInput {
    direction: string;
    carrierCode: string;
    fAppliedUsd: number;
    fcBand: string;
}

interface CanonicalPricing {
    direction: string;
    carrier_code: string;
    f_applied_usd: number;
    fc_band: string;
}

function buildCanonicalTrip(input: CanonicalTripInput): CanonicalTrip {
    return {
        trip_id: input.tripId,
        carrier_code: input.carrierCode,
        mode: input.mode,
        depart_city_code: input.departCityCode,
        arrive_city_code: input.arriveCityCode,
        depart_wid: input.departWid,
        arrive_wid: input.arriveWid,
        is_routed: input.isRouted,
        transfer_count: input.transferCount,
        ticket_price_usd: input.ticketPriceUsd,
    };
}

function buildCanonicalPricing(input: CanonicalPricingInput): CanonicalPricing {
    return {
        direction: input.direction,
        carrier_code: input.carrierCode,
        f_applied_usd: input.fAppliedUsd,
        fc_band: input.fcBand,
    };
}

// A trip is considered "routed" when it is composed of more than one leg.
// The per-leg `isRouted` flag on individual Trip objects (from isRoutedTrip)
// reflects whether the leg itself has a triplegs array, which legs never do,
// so it is always false — see #902. Compute routing from trip set length.
function isTripSetRouted(tripSet: unknown[]): boolean {
    return tripSet.length > 1;
}

export type {
    CanonicalPricing,
    CanonicalPricingInput,
    CanonicalTrip,
    CanonicalTripInput,
};

export { buildCanonicalPricing, buildCanonicalTrip, isTripSetRouted };
